import store from "@utils/store/cookie";
import { getUserInfo } from "@api/user";
import dialog from "@utils/dialog";

const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  qx:4,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  userInfo: {},
  uid: store.get("uid") || null,
  storeItems: store.get("storeItems") || null,
  goName: store.get("goName") || ""
};

const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, datas) {
	    const userinfo = {
            uid: datas.uid,
            username: datas.username,
			 ygname: datas.ygname,
            dm_id: datas.dm_id,
            dm_name: datas.dm_name,
            qx: datas.qx,
			goodslist: datas.goodslist 
          };
		   state.qx = datas.qx;
		   state.userInfo = userinfo;
		  // console.log(userinfo);
		   
		 localStorage.setItem('userInfo', JSON.stringify(userinfo));
		   
		   
	// localStorage.setItem('uid', datas.uid);
	 // localStorage.setItem('qx', datas.qx);
	 //  localStorage.setItem('username', datas.username);
	  // localStorage.setItem('dm_id', datas.dm_id);
	  // localStorage.setItem('dm_name', datas.dm_name);
	   // localStorage.setItem('goodslist', datas.goodslist);
		
		
    store.set(LOGIN_KEY, datas.uid);
     store.set("uid", datas.uid);
	  store.set("username", datas.username);
	   store.set("ygname", datas.ygname);
	   store.set("dm_id", datas.dm_id); 
	   store.set("dm_name", datas.dm_name);
	   store.set("qx", datas.qx);
	      store.set("goodslist", datas.goodslist);
  },
  LOGOUT(state) {
	 localStorage.removeItem('userInfo'); 
 
	  state.qx = "";
    state.uid = "";
	// store.clearAll();
	// store.remove("uid");
	 // store.remove("qx");
    store.remove(LOGIN_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  GET_STORE(state, storeItems) {
    state.storeItems = storeItems;
    store.set("storeItems", storeItems);
  },
  GET_TO(state, goName) {
    state.goName = goName;
    store.set("goName", goName);
  }
};
const actions = {
  USERINFO({ state, commit }, force) {
    if (state.userInfo !== null && !force)
      return Promise.resolve(state.userInfo);
    else
      return new Promise(reslove => {
        getUserInfo().then(res => {
			console.log(res);
          commit("UPDATE_USERINFO", res.data);
          reslove(res.data);
        });
      }).catch(() => {
        dialog.error("获取信息失败!");
      });
  }
};

export default {
  state,
  mutations,
  actions
};
